import { defineAbilityFor } from "../context/Ability.context";
import { useSelector } from "react-redux";
import { selectCurrentUserRoles } from "./../store/authSlice";

export function useDefineAbility() {
  const userRoles = useSelector(selectCurrentUserRoles);

  return defineAbilityFor({ roles: userRoles });
}
